import { atom } from "@reatom/core"


function assignAtomsFromSchema(
    schema, 
    atoms, 
    main_key = 'misc', 
    init_value_callback,
    additional_schema_key = null,
){
    for (const key in schema) {
        const chain_key = `${main_key}.${key}`
        if(!Object.keys(atoms).includes(chain_key)){
            const _atom = atom(init_value_callback(schema, key))
            atoms[chain_key] = {
                schema: schema[key],
                atom: _atom,
                messages_atom: atom([])
            }
        }

        /**
         * handling the case when 2 diffenent schemas for 1 field are needed
         */
        if(additional_schema_key){
            atoms[`${additional_schema_key}:${chain_key}`] = {
                ...atoms[chain_key],
                schema: schema[key],
            }
        }
    }
    return atoms;
}


function updateAtomsFromData(
    ctx,
    data, 
    atoms, 
    main_key = 'misc', 
    value_callback,
){
    for (const [key, schema] of Object.entries(data)) {
        const chain_key = `${main_key}.${key}`
        atoms[chain_key].atom(ctx, value_callback(schema))
    }
    return atoms;
}

function flushAtoms(ctx, atoms, main_key){
    for(const [key, atom] of Object.entries(atoms)){
        if (key.match(new RegExp(`^${main_key}`))){
            atom.atom(ctx, null)
        }
    }
}

function generateFieldSchema(options){
    return {
        name:	options?.name ?? null,
        type:	options?.type ?? null,
        label:	options?.type ?? null,
        required: options?.required	?? false,
        max_length:	options?.max_length ?? null,
        min_value:	options?.min_value ?? null,
        max_value:	options?.max_value ?? null,
        choices:	options?.choices ?? [],
        help_text:	options?.help_text ?? '',
        current_value:options?.current_value ?? null,
        widget:	options?.widget ?? {}
    }
}

// field types
// 'BooleanField': 'switch',
// 'IntegerField': 'number',
// 'CharField': 'text',
// 'DateField': 'date',
// 'TimeField': 'time',
// 'ModelMultipleChoiceField': 'select',
// 'TypedChoiceField': 'select',
// 'ChoiceField': 'select',

// class ReatomHelper{

// }

// export const modelStore = {}

// export function getModel(ctx, model_name) {
//     return modelStore?.[model_name]
// }
// export function getModelAtom(ctx, model_name) {
//     return modelStore[model_name].atom
// }
// export function getModelSchema(ctx, model_name) {
//     return modelStore[model_name].schema
// }

export {
    // ReatomHelper,
    assignAtomsFromSchema,
    updateAtomsFromData,
    flushAtoms,
    generateFieldSchema
}